import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { initializeInternalAuth } from '@eforall/common';
import { environment } from './environments/environment';
import { BootstrapPage } from './pages/bootstrap/bootstrap.page';
import { routes } from './routes';


async function bootstrap() {

	await initializeInternalAuth(environment);

	bootstrapApplication(
		BootstrapPage,
		{
			providers: [
				provideZoneChangeDetection(),
				provideRouter(routes, withViewTransitions()),	// , withDebugTracing()),
				importProvidersFrom([BrowserAnimationsModule]),
				{
					provide: OVERLAY_DEFAULT_CONFIG,
					useValue: {
						usePopover: false // Forces Angular 22 to use the classic Angular 19 style overlay stacking
					}
				}
			]
		}
	).catch((err) => console.error(err));
}


bootstrap();